import React from 'react';
import AdvancedSearch from '../containers/AdvancedSearch';
import Page from '../shared/Page';

export default () => (
	<Page>
		<AdvancedSearch />
	</Page>
);
